<template>
  <v-content class="mx-4">
    <!--Menu Nevigation-->
    <!--if tap = 1-->
    <v-layout v-if="tab == 1">
      <v-flex my-2 style="text-align: left;">
        <v-icon style="color: #BDBDBD;">arrow_right</v-icon>
        <v-btn text class="px-1">
          <span style="color: #BDBDBD;">ข้อมูลคุณลักษณะเฉพาะสิ่งอุปกรณ์สายแพทย์</span>
        </v-btn>
        <v-icon style="color: #BDBDBD">arrow_right</v-icon>
        <v-btn text class="px-1">
          <span style="color: #BDBDBD" @click="$router.push('/data-medical-equipment').catch(err => {})">อุปกรณ์สายแพทย์ทั้งหมด</span>
        </v-btn>
        <v-btn text class="px-1">
          <span style="color: #527281" @click="$router.push('/data-medical-equipment').catch(err => {})">เพิ่ม/สร้างข้อมูล</span>
        </v-btn>
      </v-flex>
    </v-layout>

    <!--if tap = 2-->
    <v-layout v-if="tab == 2">
      <v-flex my-2 style="text-align: left;">
        <v-icon style="color: #BDBDBD;">arrow_right</v-icon>
        <v-btn text class="px-1">
          <span style="color: #BDBDBD;">ข้อมูลคุณลักษณะเฉพาะสิ่งอุปกรณ์สายแพทย์</span>
        </v-btn>
        <v-icon>arrow_right</v-icon>
        <v-btn text class="px-1">
          <span>ข้อมูลกลุ่มหลัก สป.</span>
        </v-btn>
      </v-flex>
    </v-layout>

    <!--if tap = 3-->
    <v-layout v-if="tab == 3">
      <v-flex my-2 style="text-align: left;">
        <v-icon style="color: #BDBDBD;">arrow_right</v-icon>
        <v-btn text class="px-1">
          <span style="color: #BDBDBD;">ข้อมูลคุณลักษณะเฉพาะสิ่งอุปกรณ์สายแพทย์</span>
        </v-btn>
        <v-icon>arrow_right</v-icon>
        <v-btn text class="px-1">
          <span>นำเข้าอุปกรณ์ สป. ด้วยไฟล์ Excel</span>
        </v-btn>
      </v-flex>
    </v-layout>

    <!--Menu Bar-->
    <v-layout class="button-taps">
      <v-flex shrink style="text-align: left;"
              @click="$router.push('/data-medical-equipment').catch(err => {})">
        <v-btn class="mr-1" @click="tab = 1" :class="{active: tab === 1}"
               style="box-shadow: none;color: white;border-bottom-left-radius: unset;border-bottom-right-radius: unset;">
          อุปกรณ์สายแพทย์ทั้งหมด
        </v-btn>
      </v-flex>
      <v-flex shrink style="text-align: left;"
              @click="$router.push({ path: '/data-medical-equipment', query: { activeTab: 2 } }).catch(err => {})">
        <v-btn
          class="mr-1" @click="tab = 2" :class="{active: tab === 2}"
          style="box-shadow: none;color: white;border-bottom-left-radius: unset;border-bottom-right-radius: unset;">
          ข้อมูลกลุ่มหลัก สป.
        </v-btn>
      </v-flex>
      <v-flex shrink style="text-align: left;"
              @click="$router.push({ path: '/data-medical-equipment', query: { activeTab: 3 } }).catch(err => {})">
        <v-btn
          class="mr-1" @click="tab = 3" :class="{active: tab === 3}"
          style="box-shadow: none;color: white;border-bottom-left-radius: unset;border-bottom-right-radius: unset;">
          นำเข้าอุปกรณ์ สป. ด้วยไฟล์ Excel
        </v-btn>
      </v-flex>
    </v-layout>

    <!-- Header Add Account -->
    <template>
      <v-layout>
        <v-flex xs12 py-4 px-3 style="text-align: left;color: white;background-color: #84A2A8;">
          <v-layout>
            <v-flex shrink mr-4>
              <span style="font-size: 24px;font-weight: bold;">เพิ่ม/สร้างข้อมูลใหม่</span>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>

      <v-layout>
        <v-flex pa-4 style="background-color: #527281;">
        </v-flex>
      </v-layout>

      <!-- Conponent Form Add Account -->
      <v-layout justify-center class="table-search">
        <v-flex>
          <form-data-tool :is-add="true"></form-data-tool>
        </v-flex>
      </v-layout>

    </template>
  </v-content>
</template>

<script>
    import FormDataTool from "../components/FormDataTool";

    export default {
        components: {
            FormDataTool,
        },
        name: "AddDataTool",
        data: () => ({
            tab: 1,
        }),
        methods: {}
    }
</script>

<style scoped>

</style>
